import classNames from "classnames";
import { ReactNode } from "react";
import "./sidebar-nav-item.scss";

export interface SidebarNavItemProps {
  readonly label: string;
  readonly icon?: ReactNode;
  readonly isActive?: boolean;
  readonly onClick?: () => void;
  readonly className?: string;
}

export default function SidebarNavItem({
  label,
  icon,
  isActive = false,
  onClick,
  className,
}: SidebarNavItemProps) {
  return (
    <button
      type="button"
      className={classNames(
        "sidebar-nav-item",
        {
          "sidebar-nav-item--selected": isActive,
          "sidebar-nav-item--text-only": !icon,
        },
        className,
      )}
      onClick={onClick}
      aria-current={isActive ? "true" : undefined}
    >
      <span className="sidebar-nav-item__content">
        {icon ? (
          <span className="sidebar-nav-item__icon" aria-hidden="true">
            {icon}
          </span>
        ) : null}
        <span className="sidebar-nav-item__label label-large-medium">{label}</span>
      </span>
    </button>
  );
}
